module.exports = __webpack_public_path__ + "img/yogesh.226a7f28.png";